import { IThiSinhActionTypes } from "../../action-types/tct/IThiSinhActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IThiSinhReducer } from "../../reducer-model/tct/IThiSinhReducer";
const iniState: IThiSinhReducer = {
  phongThiSelectedId: 0,
  dotThiId: 0,
  allThiSinhs: [],
  statusAll: eReducerStatusBase.is_not_initialization
};
export const thiSinhReducer = (state: IThiSinhReducer = iniState, action: IThiSinhActionTypes): IThiSinhReducer => {
  const phongThiId = action.payload?.phongThiId ?? 0;
  switch (action.type) {
    case "THI_SINH_CHANGE_DOT_THI_ID":
      return {
        ...state,
        dotThiId: action.payload.data

      };
    case "THI_SINH_CHANGE_PHONG_THI_ID":
      return {
        ...state,
        phongThiSelectedId: phongThiId

      };
    case "THI_SINH_LOAD_START":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_loading,
          selectedIds:[]
        }
      };
    case "THI_SINH_LOAD_SUCCESS":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_completed,
          thiSinhs: action.payload.data
        }
      };
    case "THI_SINH_LOAD_ERROR":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "THI_SINH_SHOW_EDIT_MODAL":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          thiSinhEditing: action.payload.data,
          isShowEditModal: true
        }
      };
    case "THI_SINH_CLOSE_EDIT_MODAL":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          thiSinhEditing: undefined,
          isShowEditModal: false
        }
      };
    case "THI_SINH_SAVE_START":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_saving,
        }
      };
    case "THI_SINH_SAVE_SUCCESS":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_completed,
          isShowEditModal: false
        }
      };
    case "THI_SINH_SAVE_ERROR":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "THI_SINH_DELETE_START":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_deleting,
        }
      };
    case "THI_SINH_DELETE_SUCCESS":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_need_reload,
        }
      };
    case "THI_SINH_DELETE_ERROR":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "THI_SINH_CHANGE_FOCUSED_TREEVIEW_NODE":
      return {
        ...state,
        treeViewPhongSelected: action.payload.data

      };
    case "THI_SINH_CHANGE_SELCTED_IDS":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          selectedIds: action.payload.data,
        }
      };
    case "THI_SINH_UPDATES_START":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_saving,
        }
      };
    case "THI_SINH_UPDATES_SUCCESS":
      const phongThiIds = [...Array.from(new Set(action.payload.data.map(x => x.id_dot_thi_phong))), phongThiId]
      return {
        ...state,
        ...phongThiIds.reduce((acc, phongThiId) => ({
          ...acc,
          [phongThiId]: {
            ...state[phongThiId],
            status: eReducerStatusBase.is_need_reload,
            selectedIds: []
          },
        }), {}),
      };
    case "THI_SINH_UPDATES_ERROR":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "THI_SINH_SHOW_ADD_THI_SINH_MODAL":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          isShowAddThiSinhModal: true,
        }
      };
    case "THI_SINH_CLOSE_ADD_THI_SINH_MODAL":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          isShowAddThiSinhModal: false,
        }
      };
    case "THI_SINH_INSERTS_START":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_saving
        }
      };
    case "THI_SINH_INSERTS_SUCCESS":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_need_reload,
          isShowAddThiSinhModal: false
        }
      };
    case "THI_SINH_INSERTS_ERROR":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_completed
        }
      };
    case "THI_SINH_SHOW_SBD_MODAL":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          isShowSBDModal: true
        }
      };
    case "THI_SINH_CLOSE_SBD_MODAL":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          isShowSBDModal: false
        }
      };
    case "THI_SINH_GENERATE_SBD_START":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_saving
        }
      };
    case "THI_SINH_GENERATE_SBD_SUCCESS":
      return {
        ...iniState,
        
      };
    case "THI_SINH_GENERATE_SBD_ERROR":
      return {
        ...state,
        [phongThiId]: {
          ...state[phongThiId],
          status: eReducerStatusBase.is_completed
        }
      };
    case "THI_SINH_LOAD_ALL_START":
      return {
        ...state,
        statusAll: eReducerStatusBase.is_loading
      };
    case "THI_SINH_LOAD_ALL_SUCCESS":
      return {
        ...state,
        allThiSinhs: action.payload.data,
        statusAll: eReducerStatusBase.is_completed
      };
    case "THI_SINH_LOAD_ALL_ERROR":
      return {
        ...state,
        statusAll: eReducerStatusBase.is_completed
      };
    default:
      return state;
  }
};
